import { render, staticRenderFns } from "./DashboardDailyIncome.vue?vue&type=template&id=5d310496"
import script from "./DashboardDailyIncome.vue?vue&type=script&lang=js"
export * from "./DashboardDailyIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports